const moment = require("moment");

// 快速时间选择选项
let datePickerOptions = {
  shortcuts: [
    {
      text: "今天",
      onClick(picker) {
        const end = new Date();
        end.setHours(23);
        end.setMinutes(59);
        end.setSeconds(59);
        const start = new Date();
        start.setHours(0);
        start.setMinutes(0);
        start.setSeconds(0);
        picker.$emit("pick", [start, end]);
      }
    },
    {
      text: "昨天",
      onClick(picker) {
        const oneDayTime = 24 * 60 * 60 * 1000;
        const end = new Date();
        end.setTime(end.getTime() - oneDayTime);
        end.setHours(23);
        end.setMinutes(59);
        end.setSeconds(59);
        const start = new Date();
        start.setTime(start.getTime() - oneDayTime);
        start.setHours(0);
        start.setMinutes(0);
        start.setSeconds(0);
        picker.$emit("pick", [start, end]);
      }
    },
    {
      text: "最近两天",
      onClick(picker) {
        const oneDayTime = 24 * 60 * 60 * 1000;
        const end = new Date();
        end.setHours(23);
        end.setMinutes(59);
        end.setSeconds(59);
        const start = new Date();
        start.setTime(start.getTime() - oneDayTime);
        start.setHours(0);
        start.setMinutes(0);
        start.setSeconds(0);
        picker.$emit("pick", [start, end]);
      }
    },
    {
      text: "最近七天",
      onClick(picker) {
        const oneDayTime = 24 * 60 * 60 * 1000;
        const end = new Date();
        end.setHours(23);
        end.setMinutes(59);
        end.setSeconds(59);
        const start = new Date();
        start.setTime(start.getTime() - oneDayTime * 6);
        start.setHours(0);
        start.setMinutes(0);
        start.setSeconds(0);
        picker.$emit("pick", [start, end]);
      }
    },
    {
      text: "最近十天",
      onClick(picker) {
        const oneDayTime = 24 * 60 * 60 * 1000;
        const end = new Date();
        end.setHours(23);
        end.setMinutes(59);
        end.setSeconds(59);
        const start = new Date();
        start.setTime(start.getTime() - oneDayTime * 9);
        start.setHours(0);
        start.setMinutes(0);
        start.setSeconds(0);
        picker.$emit("pick", [start, end]);
      }
    }
  ]
};

let datePickerOptionsNotContainToday = {
  // disabledDate(time) {
  //   const start = new Date();
  //   start.setTime(start.getTime() - 24 * 60 * 60 * 1000);
  //   start.setHours(0);
  //   start.setMinutes(0);
  //   start.setSeconds(0);
  //   return time.getTime() > start.getTime();
  // },
  shortcuts: [
    {
      text: "昨天",
      onClick(picker) {
        const oneDayTime = 24 * 60 * 60 * 1000;
        const end = new Date();
        end.setTime(end.getTime() - oneDayTime);
        end.setHours(23);
        end.setMinutes(59);
        end.setSeconds(59);
        const start = new Date();
        start.setTime(start.getTime() - oneDayTime);
        start.setHours(0);
        start.setMinutes(0);
        start.setSeconds(0);
        picker.$emit("pick", [start, end]);
      }
    },
    {
      text: "过去两天",
      onClick(picker) {
        const oneDayTime = 24 * 60 * 60 * 1000;
        const end = new Date();
        end.setTime(end.getTime() - oneDayTime);
        end.setHours(23);
        end.setMinutes(59);
        end.setSeconds(59);
        const start = new Date();
        start.setTime(start.getTime() - oneDayTime * 2);
        start.setHours(0);
        start.setMinutes(0);
        start.setSeconds(0);
        picker.$emit("pick", [start, end]);
      }
    },
    {
      text: "过去七天",
      onClick(picker) {
        const oneDayTime = 24 * 60 * 60 * 1000;
        const end = new Date();
        end.setTime(end.getTime() - oneDayTime);
        end.setHours(23);
        end.setMinutes(59);
        end.setSeconds(59);
        const start = new Date();
        start.setTime(start.getTime() - oneDayTime * 7);
        start.setHours(0);
        start.setMinutes(0);
        start.setSeconds(0);
        picker.$emit("pick", [start, end]);
      }
    },
    {
      text: "过去十天",
      onClick(picker) {
        const oneDayTime = 24 * 60 * 60 * 1000;
        const end = new Date();
        end.setTime(end.getTime() - oneDayTime);
        end.setHours(23);
        end.setMinutes(59);
        end.setSeconds(59);
        const start = new Date();
        start.setTime(start.getTime() - oneDayTime * 10);
        start.setHours(0);
        start.setMinutes(0);
        start.setSeconds(0);
        picker.$emit("pick", [start, end]);
      }
    },
    {
      text: "过去三十天",
      onClick(picker) {
        const oneDayTime = 24 * 60 * 60 * 1000;
        const end = new Date();
        end.setTime(end.getTime() - oneDayTime);
        end.setHours(23);
        end.setMinutes(59);
        end.setSeconds(59);
        const start = new Date();
        start.setTime(start.getTime() - oneDayTime * 30);
        start.setHours(0);
        start.setMinutes(0);
        start.setSeconds(0);
        picker.$emit("pick", [start, end]);
      }
    }
  ]
};

// 时间选择的框的快捷选项
function generateShortcuts(val, include, type, returnType) {
  let unit = "";
  let unitText = "";
  let current = "";
  let last = "";
  let next = "";
  if (type === "day") {
    unit = "days";
    unitText = "天";
    current = "今天";
    last = "昨天";
    next = "明天";
  } else if (type === "month") {
    unit = "months";
    unitText = "月";
    current = "本月";
    last = "上月";
    next = "下月";
  } else {
    unit = "years";
    unitText = "年";
    current = "今年";
    last = "去年";
    next = "明年";
  }
  return val.map(item => {
    let text = "";
    let start = "";
    let end = "";
    // -1 代表 昨天|上个月|去年
    // 1 代表 明天|下个月|明年
    // 0 代表 今天|本月|今年
    if (item === -1) {
      text = last;
      start = moment()
        .startOf(type)
        .add(item, unit);
      end = moment()
        .endOf(type)
        .add(item, unit);
    } else if (item === 0) {
      text = current;
      start = moment().startOf(type);
      end = moment().endOf(type);
    } else if (item === 1) {
      text = next;
      start = moment()
        .startOf(type)
        .add(item, unit);
      end = moment()
        .endOf(type)
        .add(item, unit);
    }

    if (include) {
      if (item < -1) {
        text = `最近${Math.abs(item)}${unitText}`;
        start = moment()
          .startOf(type)
          .add(item + 1, unit);
        end = moment().endOf(type);
      } else if (item > 1) {
        text = `未来${Math.abs(item)}${unitText}`;
        start = moment().startOf(type);
        end = moment()
          .endOf(type)
          .add(item - 1, unit);
      }
    } else {
      if (item < -1) {
        text = `过去${Math.abs(item)}${unitText}`;
        start = moment()
          .startOf(type)
          .add(item, unit);
        end = moment()
          .endOf(type)
          .add(-1, unit);
      } else if (item > 1) {
        text = `以后${Math.abs(item)}${unitText}`;
        start = moment()
          .startOf(type)
          .add(+1, unit);
        end = moment()
          .endOf(type)
          .add(item, unit);
      }
    }
    return {
      text,
      onClick(picker) {
        if (returnType === 1) {
          picker.$emit("pick", [start.valueOf(), end.valueOf()]);
        }
        if (returnType === 2) {
          picker.$emit("pick", [
            start.format("YYYY-MM-DD HH:mm:ss"),
            end.format("YYYY-MM-DD HH:mm:ss")
          ]);
        }
      }
    };
  });
}

/**
 * @desc  时间范围
 * @param params
 * @param include 是否包含今天
 * @param dateType 返回的格式 1-时间戳 2-格式化后的
 */
function shortcuts(params, include = true, dateType) {
  let isObj = Object.prototype.toString.call(params) === "[object Object]";
  if (!isObj) {
    throw new Error("传入的参数类型必须为 Object");
  }
  let { d = [], m = [], y = [] } = params;
  // d = d.sort((a, b) => a - b);
  // m = m.sort((a, b) => a - b);
  // y = y.sort((a, b) => a - b);
  return [
    ...generateShortcuts(d, include, "day", dateType),
    ...generateShortcuts(m, include, "month", dateType),
    ...generateShortcuts(y, include, "year", dateType)
  ];
}

export { datePickerOptions, datePickerOptionsNotContainToday, shortcuts };
